import useSWR from 'swr';

const { REACT_APP_API_BASE_URL } = process.env;

const useUser = (user_id: string) => {
  const url = `${REACT_APP_API_BASE_URL}/users/${user_id}`;
  const { data, error, isLoading } = useSWR(encodeURI(url));

  return {
    user: data,
    error,
    isLoading,
  };
};

export default useUser;
